module.exports = __webpack_public_path__ + "static/img/fish53.ef7114e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish53.png
// module id = BH2R
// module chunks = 0